import { isEmptyObject } from "../../lib/utils";
import i18next from "i18next";
import { useTranslation } from "react-i18next";

export const formValidator = (mode, t) => (values) => {
  let formErrors = {};

  let name = values["Name"];
  let email = values["Email"];
  let username = values["Username"];
  let password = values["Password"];
  let passwordConfirmed = values["PasswordConfirmed"];
  let typeId = values["TypeId"];
  let clientId = values["ClientId"];

  if (!name || name.trim().length == 0)
    formErrors = Object.assign(formErrors, { Name: t("users.specify") });

  if (!email || email.trim().length == 0)
    formErrors = Object.assign(formErrors, { Email: t("users.specify1") });

  if (mode == 1) {
    if (!username || username.trim().length == 0)
      formErrors = Object.assign(formErrors, { Username: t("users.specify2") });

    if (!password || password.trim().length == 0)
      formErrors = Object.assign(formErrors, { Password: t("users.specify3") });

    if (!passwordConfirmed || passwordConfirmed.trim().length == 0)
      formErrors = Object.assign(formErrors, {
        PasswordConfirmed: t("users.specify4"),
      });

    if (
      password &&
      password.trim() != "" &&
      passwordConfirmed &&
      passwordConfirmed.trim() != "" &&
      password != passwordConfirmed
    )
      formErrors = Object.assign(formErrors, {
        PasswordConfirmed: t("users.specify5"),
      });
  }

  if (typeId == 0)
    formErrors = Object.assign(formErrors, { TypeId: t("users.specify6") });
  else if (typeId == 2 || typeId == 3) {
    var clientIdInt;

    if (clientId) clientIdInt = parseInt(clientId);

    if (
      !clientId ||
      clientId.toString().trim() == "" ||
      isNaN(clientIdInt) ||
      clientIdInt < 1
    )
      formErrors = Object.assign(formErrors, { ClientId: t("users.specify7") });
  }

  if (isEmptyObject(formErrors)) return undefined;

  return formErrors;
};
